module.exports = __webpack_public_path__ + "img/52.5efb32e9.png";